import { Text } from '@chakra-ui/react';
import { Restaurant } from '@/types/restaurant';
import { LatLng } from '@/types/google/geometry';
import { calculateDistance } from '@/utils';

interface DistanceDisplayProps {
  restaurant: Restaurant;
  userLocation: LatLng;
  fontSize?: string;
  marginTop?: number;
}

export function DistanceDisplay({
  restaurant,
  userLocation,
  fontSize = 'sm',
  marginTop
}: DistanceDisplayProps) {
  const getDistanceText = () => {
    if (userLocation.lat !== 0 && userLocation.lng !== 0 && restaurant.geometry?.location) {
      const distance = calculateDistance(
        userLocation.lat,
        userLocation.lng,
        restaurant.geometry.location.lat,
        restaurant.geometry.location.lng
      );
      return `${distance} mi`;
    }
    return 'Distance unavailable';
  };

  return (
    <Text color="var(--card-text-2)" fontSize={fontSize} mt={marginTop} whiteSpace="nowrap">
      {getDistanceText()}
    </Text>
  );
}